const LAYOUTS = {
  DEFAULT: 'DefaultLayout',
  AUTH: 'AuthLayout',
} as const

export { LAYOUTS }
